/**
 * Agrupamento de letras no carrinho — Use Papoula
 *
 * As letras entram como linhas próprias (para baixar estoque de verdade), mas
 * não são exibidas: os templates as escondem e mostram "Letras: A + B" na
 * linha da peça. Este script cuida do que o Liquid sozinho não consegue:
 *
 *   1. Remover a peça remove junto as letras dela.
 *   2. Limpar letras órfãs — linhas de letra cujo grupo perdeu a peça.
 *
 * O vínculo é a propriedade oculta "_papoula_grupo", gravada na peça e em
 * cada letra no momento da adição ao carrinho.
 */
(function () {
  'use strict';

  var rotas = (window.Theme && window.Theme.routes) || {};
  var urlCart = (rotas.cart_url || '/cart');

  function lerCarrinho() {
    return fetch(urlCart + '.js', {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin'
    }).then(function (r) {
      return r.json();
    });
  }

  function atualizarLinhas(updates) {
    return fetch(urlCart + '/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ updates: updates })
    });
  }

  function grupoDe(item) {
    return (item.properties && item.properties._papoula_grupo) || null;
  }

  /** A peça é a linha do grupo que carrega a propriedade visível "Letras". */
  function ehPeca(item) {
    return !!(item.properties && item.properties.Letras);
  }

  /** Zera todas as linhas de um grupo (a peça e suas letras). */
  function removerGrupo(grupo) {
    return lerCarrinho().then(function (carrinho) {
      var updates = {};
      carrinho.items.forEach(function (item) {
        if (grupoDe(item) === grupo) updates[item.key] = 0;
      });
      if (Object.keys(updates).length === 0) return null;
      return atualizarLinhas(updates);
    });
  }

  /**
   * Remove letras cujo grupo não tem mais a peça. Cobre os caminhos que não
   * passam por este script: carrinho recuperado, remoção pelo checkout,
   * peça esgotada removida pelo Shopify.
   */
  function limparOrfas() {
    return lerCarrinho().then(function (carrinho) {
      var gruposComPeca = {};
      carrinho.items.forEach(function (item) {
        var g = grupoDe(item);
        if (g && ehPeca(item)) gruposComPeca[g] = true;
      });

      var updates = {};
      carrinho.items.forEach(function (item) {
        var g = grupoDe(item);
        if (g && !ehPeca(item) && !gruposComPeca[g]) updates[item.key] = 0;
      });

      if (Object.keys(updates).length === 0) return false;
      return atualizarLinhas(updates).then(function () {
        return true;
      });
    });
  }

  function naPaginaDoCarrinho() {
    return !!document.querySelector('[data-section-id="static-cart"]');
  }

  /** Linha de letra: tem grupo, mas não é a peça. */
  function ehLetra(item) {
    return !!(item.properties && item.properties._papoula_grupo && !item.properties.Letras);
  }

  // --- Contador do header -------------------------------------------------
  //
  // O tema reescreve o badge com cart.item_count cru, que inclui as letras
  // ocultas — um único bracelete apareceria como "3". Corrigimos o valor
  // sempre que ele for reescrito.

  var agendado = null;

  function corrigirBadge() {
    var badges = document.querySelectorAll('[data-cart-mini-count]');
    if (badges.length === 0) return Promise.resolve();

    return lerCarrinho().then(function (carrinho) {
      var visiveis = carrinho.items.reduce(function (total, item) {
        return total + (ehLetra(item) ? 0 : item.quantity);
      }, 0);
      var texto = visiveis === 0 ? '' : String(visiveis);

      badges.forEach(function (el) {
        // Só escreve se estiver errado, senão a própria escrita
        // dispararia o observador de novo, em laço.
        if (el.textContent.trim() !== texto) el.textContent = texto;
      });
    });
  }

  function observarBadge() {
    var badges = document.querySelectorAll('[data-cart-mini-count]');
    if (badges.length === 0) return;

    var observador = new MutationObserver(function () {
      clearTimeout(agendado);
      agendado = setTimeout(corrigirBadge, 50);
    });

    badges.forEach(function (el) {
      observador.observe(el, { childList: true, characterData: true, subtree: true });
    });
  }

  // --- Remoção pela página do carrinho ------------------------------------

  document.addEventListener(
    'click',
    function (evento) {
      var link = evento.target.closest('[data-cart-action="remove"]');
      if (!link) return;

      var linha = link.closest('[data-papoula-grupo]');
      if (!linha) return;

      evento.preventDefault();
      evento.stopImmediatePropagation();

      removerGrupo(linha.dataset.papoulaGrupo).then(function () {
        window.location = urlCart;
      });
    },
    true
  );

  // --- Remoção pela gaveta lateral ----------------------------------------

  document.addEventListener(
    'click',
    function (evento) {
      if (!evento.target.matches('[data-cart-mini-item-remove]')) return;

      var linha = evento.target.closest('[data-papoula-grupo]');
      if (!linha) return;

      evento.preventDefault();
      evento.stopImmediatePropagation();

      removerGrupo(linha.dataset.papoulaGrupo).then(function () {
        window.location = naPaginaDoCarrinho() ? urlCart : window.location.href;
      });
    },
    true
  );

  // --- Faxina na abertura do carrinho -------------------------------------

  if (naPaginaDoCarrinho()) {
    limparOrfas().then(function (removeu) {
      if (removeu) window.location = urlCart;
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', observarBadge);
  } else {
    observarBadge();
  }
})();
